import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { companiesApi } from "./api";
import { Button, Card, PageTitle } from "../../components/ui";
import { QueryView } from "../../components/states";
import { CompanyLocationMap } from "../../components/map/CompanyMap";

export function PublicCompanyDetailPage() {
  const { id = "" } = useParams();
  const query = useQuery({
    queryKey: ["companies", "public", id],
    queryFn: () => companiesApi.getPublic(id),
  });

  return (
    <div className="space-y-6">
      <Link to="/" className="text-sm font-bold text-brand hover:underline">
        ← 一覧にもどる
      </Link>
      <QueryView query={query}>
        {(c) => (
          <>
            <PageTitle title={c.name} subtitle={`${c.area}・${c.industryLabel}`} />
            <Card className="space-y-4">
              <div className="flex flex-wrap gap-1">
                {c.jobTypes.map((j) => (
                  <span
                    key={j}
                    className="rounded-pill bg-sky-light px-3 py-1 text-xs font-bold text-brand-dark"
                  >
                    {j}
                  </span>
                ))}
              </div>
              <div>
                <h3 className="text-sm font-bold text-slate-500">仕事内容</h3>
                <p className="mt-1 whitespace-pre-wrap text-sm text-slate-700">{c.description}</p>
              </div>
              {c.latitude != null && c.longitude != null && (
                <div>
                  <h3 className="mb-1 text-sm font-bold text-slate-500">所在地</h3>
                  <CompanyLocationMap latitude={c.latitude} longitude={c.longitude} />
                </div>
              )}
              <div className="rounded-soft bg-sky-soft p-4 text-sm text-slate-600">
                受入可能人数・条件・連絡先などの詳細は、学校アカウントでログインすると表示されます。
              </div>
            </Card>
            <Card className="bg-sky-soft text-center">
              <p className="text-sm text-slate-600">
                この企業に申し込むには学校アカウントが必要です。
              </p>
              <div className="mt-3">
                <Link to="/login">
                  <Button>ログインする</Button>
                </Link>
              </div>
            </Card>
          </>
        )}
      </QueryView>
    </div>
  );
}
